<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="relative">
    <div class="relative aspect-[1.5] lg:aspect-[1.8] 2xl:aspect-[2] w-full overflow-hidden">
      <transition
        appear
        enter-active-class="transition-opacity duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <FocalImage
          v-if="item.image"
          :key="item.image.url"
          :image="item.image"
          img-class="absolute inset-0 aspect-[1.5] lg:aspect-[1.8] 2xl:aspect-[2] w-full"
        />
      </transition>
    </div>
    <div class="relative xl:absolute xl:bottom-0 xl:left-0 xl:w-1/2 bg-white text-left p-8">
      <div class="absolute inset-x top-0 left-0 right-0 w-full h-1 overflow-hidden">
        <div
          class="bg-red-500 h-full w-full origin-left transition-transform duration-100"
          :style="{ transform: 'scaleX(' + (progressWidth / 100) + ')' }"
        />
      </div>
      <div class="mb-4">
        <IconOverlay icon="ditto" />
      </div>
      <div
        class="body-2 mb-4"
        v-html="item.description"
      ></div>
      <h3 class="heading-5 mb-2">
        {{ item.name }}
      </h3>
      <p class="caption-2">
        {{ item.title }}
      </p>
      <!-- Controls -->
      <div class="mt-10 flex justify-left gap-2">
        <button
          class="px-2 py-2 border border-red-100 bg-white text-red-600 hover:bg-red-50 hover:text-red-700"
          @click="goPrev"
        >
          <FaIcon
            name="angle-left"
            icon-style="light"
            size="lg"
          />
          <span class="sr-only">Previous</span>
        </button>
        <button
          class="px-2 py-2 border border-red-100 bg-white text-red-600 hover:bg-red-50 hover:text-red-700"
          @click="autoplay = !autoplay"
        >
          <FaIcon
            v-if="!autoplay"
            name="play"
            icon-style="light"
          />
          <FaIcon
            v-if="autoplay"
            name="pause"
            icon-style="light"
          />
          <span class="sr-only">{{ autoplay ? 'Pause' : 'Play' }}</span>
        </button>
        <button
          class="px-2 py-2 border border-red-100 bg-white text-red-600 hover:bg-red-50 hover:text-red-700"
          @click="goNext"
        >
          <FaIcon
            name="angle-right"
            icon-style="light"
            icon-size="lg"
          />
          <span class="sr-only">Next</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import type { ImageRendition } from '@/ts/types/focal-point';

interface PeopleCarouselItem {
  title: string;
  name: string;
  description: string;
  image: ImageRendition | null;
}

const props = defineProps({
  item: {
    type: Object as PropType<PeopleCarouselItem>,
    required: true
  },
  totalItems: {
    type: Number,
    default: 0
  },
  progressWidth: {
    type: Number,
    default: 0
  }
})

const currentIndex = defineModel('currentIndex', {
  type: Number,
  default: 0
});

const autoplay = defineModel('autoplay', {
  type: Boolean,
  default: false
});

const goNext = () => {
  currentIndex.value = (currentIndex.value + 1) % props.totalItems;
}

const goPrev = () => {
  currentIndex.value = (currentIndex.value - 1 + props.totalItems) % props.totalItems;
}
</script>
